<template>
  <div>
    <div class="row">
      <div class="col-md-2">
        <b-form-group label="Section layout:">
          <select class="form-control" v-model="form.layout">
            <option v-for="(value, key) in layouts" :key="key" :value="key">{{value}} layout</option>
          </select>
        </b-form-group>
      </div>
      <div class="col-md-10 text-right" v-if="form.layout">
        <button v-if="!autonomous" class="btn btn-default" @click="preview">
          <icon name="image" style="vertical-align: -2px" />Preview
        </button>
        <button class="btn btn-default" @click="addSection">Add Section</button>
      </div>
    </div>

    <div id="sectionWrapper" v-if="form.layout">
      <div
        class="col-xs-12 mt-2 accordion sectionItem"
        v-for="(section, index) in form.sections"
        :id="section.name"
        :key="section.name"
      >
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Section Label"
                  v-model="section.label"
                />
              </div>
              <div class="col-md-8 text-right">
                <p style="margin-top: 5px;">
                  <span class="pr-2 clickable" @click="addRow(index)">
                    <icon name="plus" />Add Row
                  </span>
                  <span class="pr-2 clickable" @click="delSection(index)">
                    <icon name="times" />Remove Section
                  </span>
                  <span class="pr-2 clickable" @click="configSection(index)">
                    <icon name="cog" />Section Config
                  </span>
                  <span class="clickable collapsed" v-b-toggle="`${section.name}_body`">
                    <icon name="chevron-up" class="chevron-up" />
                    <icon name="chevron-down" class="chevron-down" />
                  </span>
                </p>
              </div>
            </div>
          </div>
          <b-collapse visible :id="section.name + '_body'" class="mt-2">
            <div class="card-body sectionBody">
              <row-component
                :section="section"
                :sectionIndex="index"
                :rowData="rowData"
                :gridId="gridId"
              ></row-component>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>

    <section-config-modal ref="SectionConfigModal" @updateSectionInfo="updateSectionInfo"></section-config-modal>
  </div>
</template>

<script>
import { FORM_CONSTANTS } from '@/components/DataGrid/FormBuilder/config/constants'
import RowComponent from './RowComponent'
import SectionConfigModal from './common/SectionConfigModal'
import { Hooks } from '@/components/DataGrid/FormBuilder/template/components/hook_lists'

import { extend } from 'lodash'

export default {
  components: {
    SectionConfigModal,
    RowComponent,
  },
  name: 'section-component',
  props: {
    form: {
      type: Object,
    },
    gridId: {
      type: String,
    },
    rowData: {
      type: Object,
    },
  },
  data: () => ({
    layouts: FORM_CONSTANTS.SectionLayout,
    autonomous: false,
  }),
  methods: {
    addSection() {
      var sectionInfo = _.cloneDeep(FORM_CONSTANTS.Section)
      // set uniqueID
      sectionInfo.name = _.domUniqueID('section_')
      sectionInfo.clientKey = sectionInfo.name

      // Before hook
      let b4Run = Hooks.Section.beforeAdd.runSequence(sectionInfo)
      if (b4Run === false) {
        return
      }

      this.form.sections.push(sectionInfo)

      // After hook
      Hooks.Section.afterAdd.run(sectionInfo)
    },
    delSection(secIndex) {
      // make sure no dependencies
      if (this.form.sections[secIndex].rows.length > 0) {
        const message = `Can't remove this section because it's still have row(s) inside.`

        this.$bvToast.toast(message, {
          title: 'Error!',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 2500,
        })
        return
      }

      var sectionInfo = this.form.sections[secIndex]
      let beforeRun = Hooks.Section.beforeRemove.runSequence(sectionInfo)
      if (beforeRun === false) {
        return
      }

      // remove section
      this.form.sections.splice(secIndex, 1)

      // final hook
      Hooks.Section.afterRemove.run(sectionInfo)
    },
    configSection(secIndex) {
      var sectionInfo = this.form.sections[secIndex]
      this.$refs.SectionConfigModal.openModal(sectionInfo, secIndex)
    },
    traverseSection() {
      let self = this

      // prepare data
      var items = $(this.$el).find('#sectionWrapper .sectionItem')
      var finalItems = []

      // sort
      _.each(items, (item, index) => {
        var id = $(item).attr('id')
        var sectionItem = _.find(self.form.sections, { name: id })
        sectionItem.order = index
        finalItems.push(sectionItem)
      })

      // reset the current sections
      this.form.sections = finalItems
    },
    addRow(secIndex) {
      var rowInfo = _.cloneDeep(FORM_CONSTANTS.Row)

      // general row_name (id)
      rowInfo.name = _.domUniqueID(this.form.sections[secIndex].name + '_row_')

      // before hook
      let b4Run = Hooks.Row.beforeAdd.runSequence(
        rowInfo,
        this.form.sections[secIndex]
      )
      if (b4Run === false) {
        return
      }

      this.form.sections[secIndex].rows.push(rowInfo)

      // after hook
      Hooks.Row.afterAdd.run(rowInfo, this.form.sections[secIndex])
    },
    preview() {
      this.$parent.preview()
    },
    updateSectionInfo(sectionInfo, index) {
      extend(this.form.sections[index], sectionInfo)
    },
  },
  created() {
    this.$nextTick(() => {
      let parentInst = this

      while (!$(parentInst.$el).hasClass('form-builder-root')) {
        parentInst = parentInst.$parent
      }

      this.autonomous = parentInst.autonomous
    })
  },
  mounted() {
    let self = this

    $('#sectionWrapper').sortable({
      cursor: 'move',
      delay: 200,
      update: function(event, ui) {
        self.traverseSection()
      },
    })
  },
  updated() {
    this.form._uniqueId = Math.random()
  },
}
</script>

<style scoped>
.sectionBody {
  /*padding: 30px 0;*/
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.clickable {
  cursor: pointer;
}

.accordion .collapsed .chevron-up,
.accordion .chevron-down {
  display: none;
}

.accordion .collapsed .chevron-down,
.accordion .chevron-up {
  display: inline-block;
}
</style>
